import { ModalWrapper } from "@/components/modals/modal-wrapper";
import { useConfirmModalKeys } from "@/hooks/use-confirm-modal-keys";
import { popModal } from "@/stores/modal";
import { Button } from "@/toggle-ui-kit/button";
import { useEffect, useRef } from "react";

interface RemoveTagFromCellsConfirmModalProps {
  tagKoLabel: string;
  cellCount: number;
  /** 기초/기말로 갈라진 태그라 hover 로 비춘 셀보다 넓은 범위가 지워질 때 안내한다. */
  includesAllPeriods: boolean;
  onConfirm: () => void;
  /** 모달이 화면에 뜰 때 한 번 호출된다. */
  onOpen: () => void;
  /** 확인·취소·바깥 클릭 등 어떤 경로로든 모달이 닫힐 때 한 번 호출된다. */
  onDismiss: () => void;
}

export const RemoveTagFromCellsConfirmModal = ({
  tagKoLabel,
  cellCount,
  includesAllPeriods,
  onConfirm,
  onOpen,
  onDismiss,
}: RemoveTagFromCellsConfirmModalProps) => {
  // 삭제 대상 미리보기의 수명을 모달 수명에 가둔다 — 모달이 안 뜨면 켜지지도 않는다.
  const onOpenRef = useRef(onOpen);
  const onDismissRef = useRef(onDismiss);
  useEffect(() => {
    onOpenRef.current();
    const dismiss = onDismissRef.current;
    return () => dismiss();
  }, []);

  const handleConfirm = () => {
    popModal();
    onConfirm();
  };

  const modalRef = useConfirmModalKeys(handleConfirm);

  const scope = includesAllPeriods ? "기초·기말 포함 " : "";
  const description = `'${tagKoLabel}' 태그가 ${scope}${cellCount}개 셀에서 제거됩니다.`;

  return (
    <ModalWrapper
      ref={modalRef}
      className="flex w-[548px] flex-col gap-0 rounded-lg border border-line-normal bg-white p-0 shadow-2xl"
    >
      <div className="flex flex-col gap-2 px-6 pt-5">
        <h2 className="label-1-normal-semibold text-label-normal">태그 삭제</h2>
        <p className="label-2-medium text-label-alternative">{description}</p>
      </div>

      <div className="flex justify-end gap-2 px-6 pb-5 pt-5">
        <Button
          variant="outlined"
          size="base"
          onClick={popModal}
          className="min-w-[74px]"
        >
          취소
        </Button>
        <Button
          variant="solid"
          size="base"
          onClick={handleConfirm}
          className="min-w-[74px] bg-status-negative"
        >
          삭제
        </Button>
      </div>
    </ModalWrapper>
  );
};
